import React from "react";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { styles } from "./StatsViews.styles";
import { StatsTable } from "../StatsTable";
import { useSelector } from "react-redux";
import { IStatsFilters } from "../StatsFilter/StatsFilter";
import { IColumnMapping } from "../../../../components/CsvExport/CsvExportButton";
import { convertDateToFullDateTime } from "../../../../../utilities/dateTimeUtils";
import { IUniversalTableColumn } from "../../../../components/UniversalTable/interfaces";
import { exportMultipleOrderItems } from "../ExportHelper";

const summaryColumns: IUniversalTableColumn[] = [
    {
        type: "price",
        title: "Total sale",
        field: "totalSale"
    },
    {
        type: "text",
        title: "Number of Orders",
        field: "noOrders"
    },
    {
        type: "text",
        title: "Unique users",
        field: "uniqueUsers"
    }
];

const summaryDataExportMapping: IColumnMapping[] = [
    {
        key: "totalSale",
        label: "Total sale"
    },
    {
        key: "noOrders",
        label: "Number of Orders"
    },
    {
        key: "uniqueUsers",
        label: "Unique users"
    }
];

export interface IOneOffsViewProps extends WithStyles<typeof styles> {
    from?: number;
    to?: number;
    filters?: IStatsFilters;
}

const OneOffsViewPure: React.FunctionComponent<IOneOffsViewProps> = ({
    from,
    to,
    filters,
    classes
}: IOneOffsViewProps) => {
    const productsOverview = useSelector(state => state.products);

    const oneOffs = useSelector(state => state.statistics.oneOffs);

    const dataColumns: IUniversalTableColumn[] = [
        {
            type: "dateTime",
            title: "Created on",
            field: "created"
        },
        {
            type: "text",
            title: "Order ID",
            field: "orderId"
        },
        {
            type: "text",
            title: "Order Status",
            field: "state"
        },
        {
            type: "boolean",
            title: "Archived",
            field: "isArchived"
        },
        {
            type: "text",
            title: "Payment method",
            field: "paymentMethod"
        },
        {
            type: "text",
            title: "Company",
            field: "company"
        },
        {
            type: "text",
            title: "First name",
            field: "firstName"
        },
        {
            type: "text",
            title: "Last name",
            field: "lastName"
        },
        {
            type: "text",
            title: "Email",
            field: "email"
        },
        {
            type: "text",
            title: "SAP BP-ID",
            field: "bpId"
        },
        {
            type: "text",
            title: "SAP BP-Name",
            field: "bpName"
        },
        {
            type: "price",
            title: "Price",
            field: "price"
        },
        {
            type: "products",
            title: "Items",
            field: "orderItems",
            allProducts: productsOverview.products
        },
        {
            type: "text",
            title: "By Admin",
            field: "byAdmin"
        }
    ];

    const dataExportMapping: IColumnMapping[] = [
        {
            label: "Created on",
            key: "created",
            mappingFunc: value => convertDateToFullDateTime(value)
        },
        {
            label: "Order ID",
            key: "orderId"
        },
        {
            label: "Order Status",
            key: "state"
        },
        {
            label: "Archived",
            key: "isArchived",
            mappingFunc: value => (value ? "Yes" : "No")
        },
        {
            label: "Payment method",
            key: "paymentMethod"
        },
        {
            label: "Company",
            key: "company"
        },
        {
            label: "First name",
            key: "firstName"
        },
        {
            label: "Last name",
            key: "lastName"
        },
        {
            label: "Email",
            key: "email"
        },
        {
            key: "bpId",
            label: "SAP BP-ID"
        },
        {
            key: "bpName",
            label: "SAP BP-Name"
        },
        {
            label: "Price",
            key: "price"
        },
        {
            label: "Items",
            key: "orderItems",
            mappingFunc: value => exportMultipleOrderItems(value, productsOverview)
        },
        {
            key: "byAdmin",
            label: "By Admin"
        }
    ];

    return (
        <>
            <StatsTable
                dataColumns={dataColumns}
                summaryColumns={summaryColumns}
                data={oneOffs?.data || []}
                summaryData={oneOffs?.summary || []}
                exportFilePrefix={`one_offs_${from}_to_${to}`}
                dataExportMapping={dataExportMapping}
                summaryDataExportMapping={summaryDataExportMapping}
            />
        </>
    );
};

export const OneOffsView = withStyles(styles)(OneOffsViewPure);
